import { futureCancelDateValidationObject } from 'Forms/CancelFormV2/components/FutureCancelDate';
import { getAppText } from 'Utils/text';
import * as Yup from 'yup';
import { CancelReasonAkaTravel } from './cancelAkaTravelForm.constants';
import { shouldHaveFutureCancelDateAkaTravel } from './cancelAkaTravelForm.helpers';
import { CancelAkaTravelFormValues } from './cancelAkaTravelForm.types';

export const getAkaTravelCancellationValidationSchema = (
  maxDateAllowed: number,
): Yup.ObjectSchema<CancelAkaTravelFormValues> => {
  return Yup.object()
    .shape({
      cancelReason: Yup.mixed<CancelReasonAkaTravel>().required(
        getAppText('cancelForm.cancelReason.validation.required'),
      ),
      ...futureCancelDateValidationObject(
        maxDateAllowed,
        shouldHaveFutureCancelDateAkaTravel,
      ),
    })
    .defined();
};
